import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top whenever the route's pathname changes. A SPA
// doesn't reset scroll on navigation the way a full page load does, so
// without this a new page opens at the previous page's scroll offset.
// Keyed on pathname only (not search/hash) so in-page anchor links and
// query-param updates don't yank the user back to the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // iOS WKWebView can scroll the documentElement/body rather than the
    // window object, so reset those too for a reliable top.
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
